<template>
  <div
    v-on-click-outside="() => $emit('closeModal')"
    data-cy="contacts-modal"
    class="z-1 bg-grey-hover"
    :class="[
      !ignorePlacement && {
        'left-28 top-7': position === 'bottom',
        'bottom-12 left-0': position === 'top'
      },
      { absolute: !ignorePlacement }
    ]"
  >
    <contacts-list
      v-if="contacts"
      :id="value.id"
      :deal="value"
      :contacts="contacts"
      class="max-h-70 min-h-40 w-90 overflow-y-auto bg-grey-hover p-2"
    />
  </div>
</template>
<script lang="ts" setup>
import { onMounted } from "vue";
import { useContacts } from "@/hooks/contacts";
import ContactsList from "@/views/deals/components/contacts/ContactsList.vue";
import type { PropType } from "vue";
import type {
  ContactProfile,
  ApplicationWithContactData
} from "@/models/applications";
import type { ContactTelephones } from "@/models/communicationLogs";
import { getContactsWithCalleeType } from "@/helpers/communication";
import { CalleeType } from "@/enums/communicationLogs";

const props = defineProps({
  value: {
    type: Object as PropType<ApplicationWithContactData>,
    required: true
  },
  position: {
    type: String as PropType<"top" | "bottom">,
    default: "bottom"
  },
  ignorePlacement: {
    type: Boolean,
    default: false
  }
});

const { contacts, setContacts } = useContacts();

onMounted(() => {
  if (props.value?.personal_information) {
    const contactsWithCalleeType = getContactsWithCalleeType({
      business: props.value.business,
      owners: [
        props.value.personal_information,
        ...(props.value.business?.other_owners || [])
      ]
    });
    const contactsInfo = contactsWithCalleeType.map((contact) => {
      if (
        contact.callee_type === CalleeType.Business &&
        !contact.telephones?.length
      ) {
        return {
          ...contact,
          telephones: contact.all_telephones?.map(({ number }) => number) || []
        };
      }
      return contact;
    });
    setContacts(props.value.id, contactsInfo);
    return;
  }
  const contactsInfo = [
    {
      business_legal_name: props.value.name,
      telephones:
        props.value?.phone_numbers?.map((business) => business.phone_number) ||
        []
    },
    ...(props.value?.relationships?.reduce((acc: ContactProfile[], entity) => {
      if (entity.type === "owner") {
        acc.push(entity.profile);
      }
      return acc;
    }, []) || [])
  ] as ContactTelephones[];
  setContacts(props.value.id, contactsInfo);
});
</script>
